import { useForm } from '@common-fe/common-fe';

export enum ExcessContributionFormField {
  excessAmount = 'excessAmount',
  excessEarningsAmount = 'excessEarningsAmount',
}

export interface ExcessContributionFormData {
  [ExcessContributionFormField.excessAmount]: string;
  [ExcessContributionFormField.excessEarningsAmount]: string;
}

export const useExcessContributionForm = () =>
  useForm<ExcessContributionFormData>({
    defaultValues: {
      [ExcessContributionFormField.excessAmount]: '',
      [ExcessContributionFormField.excessEarningsAmount]: '',
    },
  });
